/*************************************************/
/* HEADER                                        */
/*************************************************/

export function header() {
    let prevScrollPos = window.pageYOffset;
    let isAtTop = true;
    let ticking = false;

    const header = document.querySelector(".header");
    const headerMain = document.querySelector(".header__main");
    const logoWhite = document.querySelector(".logo-wrap");
    const logoDark = document.querySelector(".logo-wrap-dark");

    const classes = {
        headerSticky: "header-sticky",
        logoHidden: "logo-wrap--hidden",
        logoShown: "logo-wrap--shown"
    };

    const topOffset = window.innerWidth <= 768 ? "-80px" : "-110px";
    const headerBottom = header.offsetTop + header.offsetHeight;

    const setHeaderStyles = (styles) => {
        Object.assign(header.style, styles);
    };

    const toggleClass = (element, className, condition) => {
        if (element) {
            element.classList.toggle(className, condition);
        }
    };

    const activateStickyHeader = () => {
        setHeaderStyles({ top: "0", backgroundColor: "#FFFFFF" });
        headerMain.style.height = window.innerWidth <= 768 ? "80px" : "110px";

        toggleClass(header, classes.headerSticky, true);

        if (logoDark) {
            toggleClass(logoDark, classes.logoHidden, true);
            toggleClass(logoWhite, classes.logoHidden, false);
            toggleClass(logoWhite, classes.logoShown, true);
        }
    };

    const resetHeader = () => {
        setHeaderStyles({ top: "0", backgroundColor: "" });
        headerMain.style.height = window.innerWidth <= 768 ? "80px" : "110px";

        toggleClass(header, classes.headerSticky, false);

        if (logoDark) {
            toggleClass(logoDark, classes.logoHidden, false);
            toggleClass(logoWhite, classes.logoShown, false);
            toggleClass(logoWhite, classes.logoHidden, true);
        }

        isAtTop = true;
    };

    const onScroll = () => {
        const currentScrollPos = window.scrollY;

        if (prevScrollPos < currentScrollPos) {
            // Scrolling down
            setHeaderStyles({ top: topOffset });
            isAtTop = false;
        } else {
            // Scrolling up
            if (!isAtTop || currentScrollPos < headerBottom) {
                activateStickyHeader();
            }
        }

        if (currentScrollPos <= 0) {
            resetHeader();
        }

        prevScrollPos = currentScrollPos;
        ticking = false;
    };

    const onScrollThrottled = () => {
        if (!ticking) {
            requestAnimationFrame(onScroll);
            ticking = true;
        }
    };

    window.addEventListener("scroll", onScrollThrottled);
}
